const DisaHero = ({
    heading = 'working',
    caption = 'working',
    buttonText,
    buttonLink,
    image = '/api/placeholder/800/600',
    showShadowOnImage = false,
    width = 'w-1/2',
}) => {
    const getWidthClass = () => {
        switch (width) {
            case 'w-1/2':
                return 'md:w-1/2';
            case 'w-1/3':
                return 'md:w-1/3';
            case 'w-2/3':
                return 'md:w-2/3';
            case 'w-full':
                return 'md:w-full';
            default:
                return 'md:w-1/2';
        }
    };

    return (
        <div id="page-1" className="bg-opacity-80 pb-12 md:pb-40 px-4 md:px-0">
            {/* Mobile Image */}
            <img
                src={image}
                alt={heading}
                className="md:hidden mt-8 w-full max-w-sm mx-auto rounded-lg"
                id="top-image"
            />

            <div id="content" className="mt-8 md:mt-5">
                <div className="w-full flex flex-col md:flex-row md:mt-[-2vw]">
                    {/* Left Content */}
                    <div
                        id="left"
                        className={`w-full ${getWidthClass()} md:px-12 md:pt-32 md:ml-10`}
                    >
                        <h1 className="hello_text text-3xl md:text-5xl font-bold mt-4 md:mt-[3vw] text-gray-800 leading-tight">
                            {heading}
                        </h1>

                        <p className="my-4 md:my-5 text-gray-600 text-base md:text-lg font-semibold">
                            {caption}
                        </p>

                        {buttonLink && buttonText && (
                            <a href={buttonLink}>
                                <button className="hello_button w-full md:w-auto py-3 px-12 md:py-2 md:px-8 bg-blue-500 rounded-md mt-6 md:mt-0 shadow-xl hover:shadow-none transition duration-300">
                                    <span className="font-bold text-white">
                                        {buttonText}
                                    </span>
                                </button>
                            </a>
                        )}
                    </div>

                    {/* Desktop Image */}
                    <div className="hidden md:flex md:flex-1 items-end justify-center mt-10">
                        <img
                            src={image}
                            alt={heading}
                            className={`
                                w-full
                                max-w-xl
                                lg:max-w-lg
                                rounded-lg
                                ${showShadowOnImage ? 'shadow-xl' : ''}
                                transition-transform
                                duration-700
                                ease-out
                                hover:scale-105
                            `}
                            id="bottom"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DisaHero;
